import React, {useEffect} from 'react';
import Loader from './WandbLoader';
import {Auth} from '../setup';
import makeComp from '../util/profiler';

interface LogoutProps {
  auth?: Auth;
}

const Logout: React.FC<LogoutProps> = makeComp(
  ({auth}) => {
    useEffect(() => {
      auth?.logout();
      // eslint-disable-next-line
    }, []);
    return <Loader />;
  },
  {id: 'Logout'}
);

export default Logout;
